import VisaStocklistView from "./visastocklistview";

export default function VisaStockNew() {
  return (
    <VisaStocklistView
      titles={[
        "S.NO", "VRF REFERENCE NO", "VISA PROVIDER NAME", "VISA PROFESSION",
        "NATIONALITY", "CITY OF STAMPING", "VISA BLOCK NUMBER",
        "VISA BLOCK RECEIVED DATE", "SPONSOR ID", "TOTAL VISAS",
        "VISA ISSUE DATE", "VISA BLOCK ISSUE DATE", "VISA BLOCK EXPIRY DATE",
      ]}
    />
  );
}
